import React from 'react';
import {Layer} from "react-map-gl/mapbox";
import {CircleLayerSpecification, FilterSpecification, HeatmapLayerSpecification} from "mapbox-gl";

// Types ----

type HeatLayerProps = {
  id: string
  source?: string
  filter?: FilterSpecification
}

// Component ----

function VisitorDensityLayer({id, source, filter = ["all"]}: HeatLayerProps) {
  return (
    <>
      <Layer
        id={`${id}-heat`}
        source={source}
        type="heatmap"
        maxzoom={19}
        paint={heatPaint}
        filter={filter}
      />

      <Layer
        id={`${id}-point`}
        source={source}
        type="circle"
        minzoom={18}
        paint={pointPaint}
        filter={filter}
      />
    </>
  );
}

// Styles ----

const heatPaint: HeatmapLayerSpecification['paint'] = {
  // Increase the heatmap weight based on frequency and property 'magnitude'
  'heatmap-weight': ['interpolate', ['linear'], ['get', 'weight'],
    0, 0,
    6, 1,
  ],

  // Increase the heatmap color weight by zoom level
  // heatmap-intensity is a multiplier on top of heatmap-weight
  'heatmap-intensity': ['interpolate', ['linear'], ['zoom'],
    0, 0.5,
    9, 1.2,
  ],

  // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
  // Begin color ramp at 0-stop with a 0-transparency color
  // to create a blur-like effect.
  'heatmap-color': ['interpolate', ['linear'], ['heatmap-density'],
    0, 'rgba(92,202,172, 0)',
    0.2, 'rgb(92,202,172)',
    0.4, 'rgb(16,172,132)',
    0.6, 'rgb(254,202,87)',
    0.8, 'rgb(255,159,67)',
    1, 'rgb(238,82,83)',
  ],

  // Adjust the heatmap radius by zoom level
  'heatmap-radius': ['interpolate', ['linear'], ['zoom'],
    0, 2,
    20, 20,
  ],

  // Transition from heatmap to circle layer by zoom level
  'heatmap-opacity': ['interpolate', ['linear'], ['zoom'],
    20, 1,
    23, 0,
  ],
}

const pointPaint: CircleLayerSpecification['paint'] = {
  'circle-color': '#f59e0b',
  'circle-stroke-color': 'white',
  'circle-stroke-width': 1,

  // Transition from heatmap to circle layer by zoom level
  'circle-stroke-opacity': ['interpolate', ['linear'], ['zoom'],
    18, 0,
    20, 1,
  ],

  'circle-opacity': ['interpolate', ['linear'], ['zoom'],
    18, 0,
    20, 1,
  ]
}

// Export ----

export default VisitorDensityLayer;